import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';

// Styled Product Button
const StyledProductButton = styled.button`
	display: flex;
	justify-content: center;
	color: #ffffff !important;
	text-align: center;
	font-family: Arial;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 130%; /* 18.2px */
	letter-spacing: -0.48px;
	text-transform: uppercase;
	display: flex;
	padding: 12px 24px;
	justify-content: center;
	align-items: center;
	gap: 8px;
	align-self: stretch;
	border-radius: var(--Small-Radius, 4px);
	background: var(--WSJ-Primary-Red-500, #e92440);
	width: 141px;
	height: 44px;
	margin-left: 44px;
	border: 1px;
	.fox & {
		background: #2954b6;
		font-family: Roboto;
		font-size: 14px;
		font-style: normal;
		font-weight: 600 !important;
		line-height: 16px;
		letter-spacing: 0.42px;
		text-transform: uppercase;
	}
	.bon & {
		background: #827aba;
		font-family: 'FuturaPT', sans-serif;
		color: var(--Base-Colors-White, #fff);
		text-align: center;
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: 22px;
		letter-spacing: 0.48px;
		text-transform: uppercase;
		border-radius: 0px;
	}
	.law & {
		font-family: 'Roboto';
		font-weight: 600;
		background: #117b53;
		font-size: 14px;
	}
	.osw & {
		font-family: 'Roboto' !important;
		font-weight: 700;
		background: #890419;
		font-size: 14px;
		border-radius: 24px;
	}
	.npr & {
		font-family: 'Roboto';
		font-weight: 600;
		background: #da252b;
		font-size: 14px;
	}
`;

const ProductButton = ({ href = '#', text, className, voucherCopy = [] }) => {
	// const scrollToBottomMinusTenPercent = (e) => {
	// 	e.preventDefault(); // Prevent the default anchor link behavior

	// 	// Find the target element with the ID "lp-form"
	// 	const targetElement = document.querySelector(
	// 		'#us-checkout-app > div > div > div > form'
	// 	);

	// 	if (targetElement) {
	// 		// Smoothly scroll to the target element
	// 		targetElement.scrollIntoView({
	// 			behavior: 'smooth',
	// 		});
	// 	} else {
	// 		console.warn('Element with ID "lp-form" not found.');
	// 	}
	// };

	const handleClick = (e) => {
		e.preventDefault();
		// Scroll to step-2 if user is not logged in, step-3 if logged in
		const selector =
			voucherCopy?.length > 0
				? '.new-voucher-style'
				: window.dataLayer[0].visitorTypeDetailed === 'Unidentified'
				? '.scroll-to-step-2'
				: '.scroll-to-step-3';
		const paymentContainer = document.querySelector(selector);
		if (paymentContainer) {
			const elementPosition = paymentContainer.getBoundingClientRect().top;
			const offsetPosition = elementPosition + window.pageYOffset - 200;
			window.scrollTo({
				top: offsetPosition,
				behavior: 'smooth',
			});
		}
	};

	return (
		<StyledProductButton
			href={href}
			className={className}
			// onClick={scrollToBottomMinusTenPercent}
			onClick={handleClick}
		>
			{text}
		</StyledProductButton>
	);
};

export default ProductButton;
